export const D4SignMessageMap: Record<string, string> = {
  "" : "",
  "Signed": "Assinado",
  "Finished document": "Assinado",
  "Refused": "Recusado",
  "Expired": "Expirado"
}